import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { PoliticasCreditoOficina } from '../_models/politicas-credito-oficina';

@Injectable({
  providedIn: 'root'
})
export class PoliticasCreditoOficinaService {

  private rutServicioCanal = AppSettings.rutServiciosPOLITICA + '/api/politicasCreditosOficinas';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listadoPoliticas() {
    return this.httClient.get( this.rutServicioCanal ).pipe( map( res => res as PoliticasCreditoOficina[] ) );
  }

  listadoPoliticasHabilitados() {
    return this.httClient.get( this.rutServicioCanal + '/enabled' ).pipe( map( res => res as PoliticasCreditoOficina[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicioCanal + '/' + id ).pipe( map( res => res as PoliticasCreditoOficina ) );
  }

  obtenerPorIdPoliticaCredito( id: string ) {
    return this.httClient.get( this.rutServicioCanal + '/politicaCredito/' + id ).pipe( map( res => res as PoliticasCreditoOficina[] ) );
  }

  crear( data: PoliticasCreditoOficina ) {
    data.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicioCanal, data ).pipe( map( res => res as PoliticasCreditoOficina ) );
  }

  actualizar( data: PoliticasCreditoOficina ) {
    data.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicioCanal, data ).pipe( map( res => res as any ) );
  }

  bulk( regActualizar: PoliticasCreditoOficina[] ) {
    regActualizar.map( ( s: PoliticasCreditoOficina ) => {
      s.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    } );
    return this.httClient.post( this.rutServicioCanal + '/bulk', regActualizar  ).pipe( map( res => res as any ) );
  }


}
